module.exports = {"docType":"<!DOCTYPE html>","defaultKeysToFilter":["settings","enrouten","_locals"],"client":{"markupId":"react-engine-props"},"staticMarkup":false,"scriptType":"application/json"}


//////////////////
// WEBPACK FOOTER
// ./~/react-engine/lib/config.json
// module id = 3
// module chunks = 0